import QuestionService from '../services/question.service';
import Vue from 'vue';

export const question = {
  namespaced: true,
  state: {
    questionList: [],
    isLoading: false,
  },
  actions: {
    async getQuestionList({ commit }, params) {
      try{
        commit('SET_IS_LOADING', true);
        const resp = await QuestionService.getQuestionList(params);
        commit('SET_IS_LOADING', false);
        return resp.data;
      }catch(error){
        if(error.response){
          commit('SET_IS_LOADING', false);
          return error.response
        }else if (error.request) {
          commit('SET_IS_LOADING', false);
          return error.request
        } else {
            commit('SET_IS_LOADING', false);
            return error
        }
      }
    },
    async getQuestionById(_, questionId) { 
      try{
        const resp = await QuestionService.getQuestionById(questionId);
        return resp.data
      }catch(error){
        if(error.response){
          return error.response
        }else if (error.request) {
          return error.request
        } else {
            return error
        }
      }
    },

    async createQuestion(_, newQuestion) {
      const datedQuestion = {
        ...newQuestion,
        dtCadastro: new Date(),
      };
      const resp = await QuestionService.createQuestion(datedQuestion);
      return resp.status;
    },

    async editQuestion(_, currentQuestion) {
      const resp = await QuestionService.editQuestion(currentQuestion);
      return resp.status;
    },

    async deleteQuestion(_, questionId) {
      const resp = await QuestionService.deleteQuestion(questionId);
      return resp.status;
    },

    toggleEditItem({ state, commit }, itemId) {
      const editQuestion = getCurrentQuestion(state.questionList, itemId);
      editQuestion.respostas.forEach(
        (resposta) => (resposta.isEditing = resposta.idResposta === itemId),
      );
      commit('SET_EDIT_QUESTION', editQuestion);
    },

    setNewAnswer({ commit, state }, item) {
      const editQuestion = getCurrentQuestion(
        state.questionList,
        item.idResposta,
      );
      editQuestion.respostas = editQuestion.respostas.map((itemResposta) => {
        return itemResposta.idResposta === item.idResposta
          ? {
              ...itemResposta,
              resposta: item.resposta,
              correta: item.correta,
              comentario: item.comentario,
              isEditing: false,
            }
          : { ...itemResposta };
      });
      commit('SET_EDIT_QUESTION', editQuestion);
    },

    deleteAnswer({ commit, state }, itemId) {
      const editQuestion = getCurrentQuestion(state.questionList, itemId);

      editQuestion.respostas = editQuestion.respostas.filter(
        ({ idResposta }) => idResposta !== itemId,
      );
      commit('SET_EDIT_QUESTION', editQuestion);
    },
  },
  mutations: {
    SET_QUESTION_LIST(state, questionList) {
      state.questionList = [...questionList];
    },

    SET_EDIT_QUESTION(state, questionItem) {
      const itemIndex = state.questionList.findIndex(
        ({ idQuestao }) => idQuestao === questionItem.idQuestao,
      );
      Vue.set(state.questionList, itemIndex, questionItem);
    },

    SET_EDIT_FALSE(state) {
      const questionList = state.questionList.map((question) => {
        return {
          ...question,
          respostas: question.respostas.map((resposta) => {
            return {
              ...resposta,
              isEditing: false,
            };
          }),
        };
      });
      state.questionList = [...questionList];
    },

    REMOVE_ANSWER(state, question) {
      state.questionList = state.questionList.filter(
        ({ idQuestao }) => idQuestao !== question.idQuestao,
      );
    },
    SET_IS_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
  },
};

function getCurrentQuestion(question, id) {
  return question.find((question) =>
    question.respostas.some(({ idResposta }) => idResposta === id),
  );
}
